// IMPORT PACKAGE REFERENCES
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

//COMPONENT

class FileItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isHovering: false,
        };

        this.deleteItem = this.deleteItem.bind(this);
        this.handleMouseHover = this.handleMouseHover.bind(this);
        this.handleMouseExit = this.handleMouseExit.bind(this);
    }

    handleMouseHover() {
        this.setState({
            isHovering: true
        });
    }

    handleMouseExit() {
        this.setState({
            isHovering: false
        });
    }

    deleteItem(){
        this.props.removeFile(this.props.name);
    }

    render() {
        var sizeString = '';
        if (this.props.size > 1000000) {
            sizeString = (this.props.size / 1000000).toFixed(0) + 'mb';
        } else if (this.props.size < 1000000) {
            sizeString = (this.props.size / 1000).toFixed(0) + 'kb';
        }

        let fileNameComponents = this.props.name.split('.').map(String);
        let extension = fileNameComponents[fileNameComponents.length - 1];
        let imageName = '';

        if (extension == 'png' || extension == 'jpeg' || extension == 'jpg') {
            imageName = 'image-icon.png';
        } else if (extension == 'usdz'){
            imageName = 'ar-icon.png';
        } else {
            imageName = 'text-icon.png';
        }

        return (
            <div className='file-list-item' onMouseEnter={this.handleMouseHover} onMouseLeave={this.handleMouseExit}>
                <div className="file-image">    
                    <img className='equipment-more-image noselect' src={require('../../images/' + imageName )} />
                </div>
                <div className="file-name">{this.props.name}</div>
                <div className="file-size">{sizeString}</div>
                {this.state.isHovering && 
                    <div>
                        <div className="delete-file-button float" onClick={this.deleteItem}>
                            <img className='file-delete-image noselect' src={require('../../images/cross.png' )} />
                        </div>
                    </div>
                }
            </div>
        );
    }
}

FileItem.propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    removeFile: PropTypes.func.isRequired
};

const hoc = withRouter(FileItem);

// EXPORT COMPONENT
export { hoc as FileItem };


// WEBPACK FOOTER //
// ./src/components/containers/FileItem.js